const config = {
  url: '/partners',
  title: 'Партнеры',
  endpoint: '/admin-search?filter=partners',
  type: 'table',
  getUrl: id => `/partner/${id}`,
  getApiUrl: id => `/partners/${id}`,
  search: true,
  key: 'partners',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
